"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const elements_ui_icon_1 = __importStar(require("@hydrogen/elements.ui.icon"));
const themes_1 = require("./themes");
const ContentBoxTitle_1 = __importDefault(require("./components/ContentBoxTitle"));
const ContentBox = (props) => {
    const layout = props.layout || 'card';
    const theme = themes_1.themes.contentBox.layouts[layout];
    const [boxResizing, setBoxResizing] = react_1.default.useState(false);
    const TagName = props.as || 'div';
    const variant = props.variant || 'default';
    const noHeader = props.noHeader || false;
    return (react_1.default.createElement(TagName, { className: (0, elements_ui_utils_1.classNames)(theme.container.shared, boxResizing ? theme.container.states.resizing : '', props.className || ''), state: props.state },
        !noHeader && (react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)(theme.header.shared, theme.header.variants[variant], props.href ? theme.header.states.linked : '') },
            react_1.default.createElement("div", { className: theme.header.inner },
                react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)((!props.options || (props.options && props.backOption))
                        && 'w-full') },
                    props.backOption && (react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)('mb-4 flex gap-4 items-center justify-between') },
                        props.backOption,
                        props.options && props.options)),
                    react_1.default.createElement(ContentBoxTitle_1.default, Object.assign({}, props)),
                    props.subTitle && (react_1.default.createElement("p", { className: (0, elements_ui_utils_1.classNames)(props.isMainBox ? 'text-base' : 'text-sm', 'mt-1 text-secondary-500 font-medium') }, props.subTitle))),
                props.options && (react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)(props.optionsAlign && props.optionsAlign, 'relative gap-3') }, props.options))))),
        react_1.default.createElement("div", { className: "h-full" }, props.children),
        props.resizable
            && (react_1.default.createElement("button", { type: "button", className: theme.resize.button, onMouseDown: () => setBoxResizing(true), onMouseUp: () => setBoxResizing(false) },
                react_1.default.createElement("span", { className: "sr-only" }, "Resize container"),
                react_1.default.createElement(elements_ui_icon_1.default, { icon: theme.resize.icon.icon, className: theme.resize.icon.text, size: elements_ui_icon_1.IconsSizes.medium })))));
};
exports.default = ContentBox;
//# sourceMappingURL=content-box.js.map